import CancelAcceptedOrganisationInvitation from './CancelAcceptedOrganisationInvitation';

export default CancelAcceptedOrganisationInvitation;
